import Text from 'components/Text/Text';
import React from 'react';
import { IItemUsers } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './MainInfoView.module.scss';

interface IMainInfoView {
	data: IItemUsers;
}

const MainInfoView: React.FC<IMainInfoView> = ({ data }) => {
	const roleClasses = classNames(style.blockValue, style.role);

	return (
		<div className={style.infoContainer} data-test="MainInfoView">
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.blockValue}
					translationKey={`${data.firstName} ${data.surName}`}
					withTooltip={true}
				/>
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="emailLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={data.email} withTooltip={true} />
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="roleLabel"
					theme="neutralLight"
				/>
				<div className={roleClasses}>
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#userRole${data.roleName}`} />
					</svg>
					<Text translationNameSpace="listing" translationKey={data.roleName} withTooltip={true} />
				</div>
			</div>
		</div>
	);
};

export default MainInfoView;
